import { render, staticRenderFns } from "./approveAdmin.vue?vue&type=template&id=60568b26&scoped=true&"
import script from "./approveAdmin.vue?vue&type=script&lang=js&"
export * from "./approveAdmin.vue?vue&type=script&lang=js&"
import style0 from "./approveAdmin.vue?vue&type=style&index=0&id=60568b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60568b26",
  null
  
)

export default component.exports